import registrationInstance from '../instance'

const postDesktopUser = (login) => {
	return registrationInstance.post('/users/desktop', { login })
}

export default postDesktopUser
